import { toast } from "sonner";
import request from "../../../helpers/request";

export const verificarCodigo2FA = async (login: string, code: string) => {
  const url = `${process.env.REACT_APP_API}/Usuario/ValidarLogin2FA?login=${login}&codigo=${code}`;
  const result = await request({
    url,
    method: "POST",
    noProtect: true,
  });

  console.log("Verificar 2FA result:", result);

  if (result.data && result.data.token) {
    toast.success("Logado com sucesso");
    return result.data;
  } else {
    throw new Error(
      result.data?.message || "O código de verificação é inválido.",
    );
  }
};
